import React from 'react';
import { SemiCircle } from './styles';

interface CardCounterProps {
  count: number;
}

const CardCounter = (props: CardCounterProps) => {
  const { count } = props;
  return <SemiCircle>{count}</SemiCircle>;
};

export default CardCounter;
